import React, { useEffect, useRef, useState } from "react";

interface Props {
  component: React.ReactElement;
  content: React.ReactElement;
}

function Popover({ component, content }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef<HTMLDivElement>(null);
  const toggleRef = useRef<HTMLDivElement>(null);

  const togglePopover = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target as Node) &&
        toggleRef.current &&
        !toggleRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleComponent = React.cloneElement(component, {
    onClick: togglePopover,
    ref: toggleRef,
  });

  const popoverContent = React.cloneElement(content, {
    children: React.Children.map(content.props.children, (child) => {
      if (
        React.isValidElement(child) &&
        typeof child.props === "object" &&
        child.props !== null &&
        "role" in child.props &&
        "id" in child.props &&
        child.props.role === "button" &&
        child.props.id === "change-tickets-close"
      ) {
        return React.cloneElement(
          child as React.ReactElement<{ onClick?: () => void }>,
          {
            onClick: () => setIsOpen(false),
          }
        );
      }
      return child;
    }),
  });

  return (
    <>
      <div ref={toggleRef}>{toggleComponent}</div>
      {isOpen && (
        <div className="popover" ref={popoverRef}>
          {popoverContent}
        </div>
      )}
    </>
  );
}

export default Popover;
